<span *ngFor="let item of data">
	<table>
		<tr>
			<th>{{ item.label }}</th>
			<th></th>
		</tr>
		<mat-progress-bar class="my-4" *ngIf="!item.data" mode="indeterminate"></mat-progress-bar>
		<span *ngIf="item.data">
			<tr>
				<td>Il. rezerwacji</td>
				<td class="ps-2">{{ item.data.reservationsAmount }}</td>
			</tr>
			<tr>
				<td>Il. uczestników</td>
				<td class="ps-2">{{ item.data.totalPersons }}</td>
			</tr>
			<tr>
				<td>Il. anulowanych uczestników</td>
				<td class="ps-2">{{ item.data.totalCancelledPersons }}</td>
			</tr>
			<tr>
				<td>Wartość</td>
				<td class="ps-2">{{ item.data.totalPrice | price }} zł</td>
			</tr>
			<tr>
				<td>Do zapłaty</td>
				<td class="ps-2">{{ item.data.totalBalance | price }} zł</td>
			</tr>
			<tr>
				<td>Prowizja</td>
				<td class="ps-2">{{ item.data.commissionValue | price }} zł</td>
			</tr>
		</span>
	</table>
</span>
